<template>
  <div>
    <h1 class="pb-3" v-if="title">{{ title }}</h1>
    <FileUpload
      @onUploadSuccess="handleUploadSuccess"
      @removeFile="onRemoveFile"
      @unselectFile="onRemoveFile"
      @show="onShow"
      @selectFile="selectFile"
      :uploadingUrl="addFileUrl"
      :fileTypes="['application/pdf']"
      :files="files"
      :isLoading="isLoading"
      :disableAutoProceed="!showPreview && !isFileUploaded"
      :disabled="readonly"
      customActions
    />
    <PDFViewFull :data="fileDialog" />
  </div>
</template>

<script>
import FileUpload from "@/components/common/FileUpload";
import APIService from "@/services/APIService";
import { DELETE_WORKER_CV } from "@/store/modules/workers/action-types";
import { mapActions } from "vuex";
import PDFViewFull from "@/components/common/PDFViewFull";
import { getToken } from "@/services/utils";

export default {
  props: {
    /**
     *  Data object
     */
    currentWorker: {
      type: Object,
      required: true
    },
    readonly: Boolean,
    title: String,
    showPreview: Boolean
  },
  components: {
    FileUpload,
    PDFViewFull
  },
  data() {
    return {
      worker: { ...this.currentWorker },
      isLoading: false,
      files: this.currentWorker.cv ? [this.currentWorker.cv] : [],
      fileDialog: {
        title: "",
        dialog: false,
        src: ""
      },
      isFileUploaded: false
    };
  },
  computed: {
    workerId() {
      return this.worker.id;
    },
    addFileUrl() {
      const host = APIService.host;
      return `${host}/users/${this.workerId}/cv`;
    }
  },
  methods: {
    ...mapActions("workers", {
      removeFile: DELETE_WORKER_CV
    }),
    selectFile({ uppyInstance, file }) {
      uppyInstance.setFileState(file.id, {
        xhrUpload: { endpoint: this.getAddFileUrl }
      });
      uppyInstance.upload(this.workerId).then(() => {
        this.isFileUploaded = true;
        this.$forceUpdate();
      });
    },
    async onRemoveFile() {
      this.isLoading = true;
      await this.removeFile(this.workerId);
      this.fileRemoved();
      this.isFileUploaded = false;
      this.isLoading = false;
    },
    fileRemoved() {
      this.files = [];
      this.worker.cv = null;
      this.handleChange();
    },
    handleChange() {
      this.$emit("onChange", this.worker);
    },
    handleUploadSuccess(file) {
      this.worker.cv = file;
      this.handleChange();
    },
    async onShow(file) {
      const token = getToken();
      this.fileDialog = {
        src: `${file.url}?token=${token}`,
        title: file.fileName,
        dialog: true
      };
    },
    isPermitted(permission) {
      return this.permissions[permission];
    }
  }
};
</script>

<style lang="scss" scoped></style>
